module.exports = __webpack_public_path__ + "e83468aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/world_map_dots@2x.png
// module id = 1215
// module chunks = 0